import React, { useEffect, useState } from 'react';
import {
    Modal, Box, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, CircularProgress, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import loyaltyService from '../../services/loyaltyService';

export const LoyaltyLevelGradesModal = ({ open, onClose }) => {
    const [grades, setGrades] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setLoading(true);
            loyaltyService.getLevelGrades()
                .then(result => setGrades(result || []))
                .catch(() => setGrades([]))
                .finally(() => setLoading(false));
        }
    }, [open]);

    return (
        <Modal open={open} onClose={onClose}>
            <Box className="modal_body loyalty_grades_modal">
                <div className="loyalty_modal_title_row">
                    <span className="loyalty_modal_title">Уровни</span>
                    <IconButton size="small" onClick={onClose} className="loyalty_modal_close">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>
                {loading ? (
                    <div className="loyalty_modal_loader">
                        <CircularProgress size={32} />
                    </div>
                ) : (
                    <TableContainer>
                        <Table size="small" className="loyalty_table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Баллы</TableCell>
                                    <TableCell>Сумма оплаты вознаграждения (шаг)</TableCell>
                                    <TableCell>Общая сумма оплаты вознаграждения (тотал)</TableCell>
                                    <TableCell>Кол-во побед (шаг)</TableCell>
                                    <TableCell>Общее кол-во побед (тотал)</TableCell>
                                    <TableCell>Кол-во участий (шаг)</TableCell>
                                    <TableCell>Общее кол-во участий (тотал)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {grades.map((grade, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell>{grade.Points}</TableCell>
                                        <TableCell>{formatAmount(grade.PaymentAmount)}</TableCell>
                                        <TableCell>{formatAmount(grade.PaymentAmountTotal)}</TableCell>
                                        <TableCell>{grade.WinAmount}</TableCell>
                                        <TableCell>{grade.WinAmountTotal}</TableCell>
                                        <TableCell>{grade.ParticipationAmount}</TableCell>
                                        <TableCell>{grade.ParticipationAmountTotal}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                <div className="loyalty_modal_footer">
                    <button className="loyalty_ok_btn" onClick={onClose}>OK</button>
                </div>
            </Box>
        </Modal>
    );
};

function formatAmount(value) {
    if (value === undefined || value === null) return '';
    const num = parseFloat(String(value).replace(/\s/g, '').replace(',', '.'));
    if (isNaN(num)) return value;
    return num.toLocaleString('ru-RU', { maximumFractionDigits: 0 });
}

